import React from 'react';
import './HeroSection.css';
import devicesImage from '../../assets/mockup.png'; 

function HeroSection() {
  return (
    <section id="hero" className="hero-section">
      <div className="hero-content">
        <h1>O cálculo que conecta peças e ideias</h1>
        <p>
          O DLOGIC foi criado para simplificar a montagem de displays, automatizando cálculos, organizando por categorias e reduzindo erros manuais com mais agilidade e clareza nos resultados.
        </p>
        <button className="btn-ver-mais">VER MAIS</button>
      </div>
      <div className="hero-images">
        <img src={devicesImage} alt="Laptop e Smartphone" className="devices-img" />
      </div>
    </section>
  );
}

export default HeroSection;